import Vue from 'vue';
import 'array-flat-polyfill';
import 'url-search-params-polyfill';
import 'custom-event-polyfill';
import platform from 'platform'
import Vue2TouchEvents from 'vue2-touch-events'

Vue.use(Vue2TouchEvents)

window.EventBus = new Vue();

export default {
  init() {
    const svea = document.getElementById('svea');

    if(platform.name === 'IE' || (platform.name === 'Edge' && platform.version.slice(0, 2) === '15')) {
      svea.innerHTML = '<p style="font-size: 32px; text-align: center; margin-top: 200px">Vi stödjer tyvärr inte din webbläsare. Använd <a href="https://www.google.com/intl/sv/chrome/">Chrome</a>, <a href="https://www.microsoft.com/en-us/edge">Edge</a> eller <a href="https://www.mozilla.org/sv-SE/firefox/new/">Firefox</a>.</p>'
      return;
    }

    Vue.component('product', require('../vue/Product.vue').default);
    Vue.component('archive-product', require('../vue/ArchiveProduct.vue').default);
    Vue.component('single-product', require('../vue/SingleProduct.vue').default);
    Vue.component('cart', require('../vue/Cart.vue').default);
    Vue.component('faq', require('../vue/Faq.vue').default);
    Vue.component('menu-wrapper', require('../vue/Menu.vue').default);
    Vue.component('search-area', require('../vue/SearchArea.vue').default);
    Vue.component('suppliers', require('../vue/Suppliers.vue').default);
    Vue.component('badge', require('../vue/Badge.vue').default);

    new Vue({
      el: (window.location.pathname.includes('cart') || window.location.pathname.includes('checkout')) ? '#header' : '#svea',
      data() {
        return {
          showNavbar: true,
          lastScrollPosition: 0,
          scrollValue: 0,
          modalOpened: false,
        }
      },

      mounted() {
        window.EventBus.$on('filter', (data) => {
          this.modalOpened = data;
        })

        this.lastScrollPosition = window.pageYOffset
        window.addEventListener('scroll', this.onScroll)
      },

      beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll)
      },

      methods: {
        onScroll() {
          if (window.pageYOffset < 0) {
            return
          }
          if (Math.abs(window.pageYOffset - this.lastScrollPosition) < 60) {
            return
          }
          this.showNavbar = window.pageYOffset < this.lastScrollPosition
          this.lastScrollPosition = window.pageYOffset

          const header = document.getElementById('header');

          if (this.showNavbar && !this.modalOpened) {
            header.classList.remove('header__hidden')
          } else {
            header.classList.add('header__hidden')
          }
        },
      },
    })
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js